// import '../styles/main.scss';

import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';
import collapse from '@alpinejs/collapse';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

// Import Swiper
import Swiper from 'swiper';
// import 'swiper/swiper-bundle.css';
import { Navigation, Pagination } from 'swiper/modules';

window.Alpine = Alpine;
window.Swiper = Swiper;
window.Fancybox = Fancybox;
Swiper.use([Navigation, Pagination]);

Fancybox.bind('[data-fancybox]', {});

Alpine.plugin(persist);
Alpine.plugin(collapse);
Alpine.start();
